module.exports = __webpack_public_path__ + "static/media/filtres.83ef37de.png";